<div class="payment-info-card" *ngIf="cardMask && cardMask.length > 0">
  <div class="payment-info-grid">
    <div class="grid-col">
      <div class="label">CARD DETAILS</div>
      <div class="card-details">
        <img class="card-brand" [src]="brandIcon" [alt]="brandName" />
        <span class="card-mask">{{ cardMask }}</span>
      </div>
      <div class="sub-text" *ngIf="formattedDate || dateTime">{{ formattedDate || dateTime }}</div>
    </div>
    <div class="grid-col">
      <div class="label">TRANSACTION ID</div>
      <div class="value">{{ transactionId || 'N/A' }}</div>
    </div>
  </div>
  <div class="payment-info-rows">
    <div class="row">
      <div class="label">BILLING ADDRESS</div>
      <div class="value">{{ billingAddress || 'N/A' }}</div>
    </div>
    <div class="row">
      <div class="label">CONTACT</div>
      <div class="value">{{ contact || 'N/A' }}</div>
    </div>
  </div>
</div>


